import axios from 'axios'

import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/lancamento.msg'
import MensagensHelper, { MSG_SUCESSO } from '@/utils/mensagens.helper'

import ApiRotas from '@/modules/services/rotas.api'
import ServiceHandler from '@/modules/services/handler/service.handler'

class LancamentoService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('servicos/lancamento', msg)
  }

  async retornaAtendimentosUsuario(idFuncionario, mostrarLucros) {
    try {
      const params = { params: mostrarLucros ? { mostrarlucros: mostrarLucros } : {} }
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/meus/${idFuncionario}`, params)
      return retorno.data
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaAtendimentosAbertosFilial(filial) {
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/abertos/${filial}`)
      return retorno.data
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async concluirAtendimento(atendimento) {
    try {
      const retorno = await axios.put(`${ApiRotas}/${this.rota}/abertos/concluir`, atendimento)
      return retorno
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async removerAtendimento(atendimentoId) {
    try {
      await axios.delete(`${ApiRotas}/${this.rota}/${atendimentoId}`)
      return MensagensHelper.gerar(MSG_SUCESSO, this.msgs.ATENDIMENTO_CANCELADO_COM_SUCESSO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async listaFaturamentos(filtroData) {
    try {
      const params = { params: { filtro: filtroData } }
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/concluidos/periodo`, params)
      return retorno.data
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }
}

export default new LancamentoService()
